<script>
import _ from "lodash";
import { mapGetters } from "vuex";

import Resultado from "./Resultado";

import { Btn, BtnGroup, BtnToolbar } from "uiv";

import Desglose from "../../../plugins/DesglosePopover.vue";
import UrlPopover from "../../Buscador/UrlPopover.vue";
import FormasDePago from "../../../plugins/FormasDePago.vue";

export default {
  mixins: [Resultado],
  components: {
    Btn,
    BtnGroup,
    Desglose,
    BtnToolbar,
    UrlPopover,
    FormasDePago,
  },
  computed: {
    ...mapGetters([
      "showConectores",
      "isAdmin",
      "isFormas",
      "isTarifaConector",
      "getURL",
    ]),
  },
  methods: {
    onUpdateProducto(datos) {
      this.$store.commit('updateProducto', {
        codigo: this.resultado.codigo,
        conector: this.resultado.proveedor,
        datos,
      });
    },
  },
};
</script>

<template>
  <div
    class="panel panel-default"
    :class="{ 'panel-hidden': !resultado.destacado }"
  >
    <div class="row">
      <div class="col-xs-12 col-sm-3">
        <div class="img-bg" :style="{ backgroundImage: `url('${urlFoto}')` }">
          <span class="label label-destacado" v-if="resultado.destacado">
            <i class="mdi mdi-star"></i> Destacado
          </span>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6">
        <div class="list-group">
          <div class="list-group-item">
              <admin-editable-name
                  :producto="resultado"
                  :is-admin="isAdmin"
                  @update:producto="onUpdateProducto"
                >
                  <h4 v-html="resultado.nombre" class="list-group-item-heading"></h4>
              </admin-editable-name>

            <div style="margin-bottom: 10px;">
              <share-button
                size="sm"
                :url="resultado.url_compartir"
                :title="resultado.nombre"
              ></share-button>
              <a
                v-if="resultado.carpeta === 'inventory'"
                class="pdf-button btn btn-sm btn-primary"
                target="_blank"
                :href="getURL(`/services/${resultado.carpeta}/pdf/${resultado.codigo}`)"
              >
                <i class="fa fa-download"></i>
                PDF
              </a>
            </div>

            <ul class="list-inline" v-if="resultado.dias || resultado.noches">
              <li><b v-html="'Duraci&oacute;n:'"></b></li>
              <li v-html="`${resultado.dias} D&iacute;as`"></li>
              <li v-html="`${resultado.noches} Noches`"></li>
            </ul>

            <ul class="list-inline">
              <li><b>Origen:</b></li>
              <li class="inicio" v-html="resultado.inicio"></li>
            </ul>

            <ul class="list-inline ciudades">
              <li><b>Ciudades:</b></li>
              <li
                v-for="(ciudad, key) in resultado.ciudades"
                v-html="`${key !== 0 ? ' - ' : ''}${ciudad}`"
                :key="key"
              ></li>
            </ul>

            <ul
              class="list-inline categorias"
              v-if="resultado.categorias.length"
            >
              <li><b v-html="'Categor&iacute;a:'"></b></li>
              <li
                v-for="(categoria, key) in resultado.categorias"
                v-html="categoria"
                :key="key"
              ></li>
            </ul>

            <ul class="list-inline">
              <li v-if="showConectores" class="proveedor">
                <b>Proveedor:</b>
                <span v-html="resultado.proveedor_nombre"></span>
              </li>
              <li v-if="showConectores && resultado.operador_nombre">
                <b>Operador:</b>
                <span v-html="resultado.operador_nombre"/>
              </li>
              <li class="codigo">
                <b v-html="'C&oacute;digo:'"></b>
                <span v-html="resultado.codigo"></span>
              </li>
            </ul>
          </div>

          <div class="list-group-item panel-admin" v-if="isAdmin">
            <div class="row">
              <div class="col-xs-12 col-sm-8">
                <admin-toolbar
                  :producto="resultado"
                  :url="getURL('')"
                  @update:producto="onUpdateProducto"
                />
              </div>
              <div class="col-xs-12 col-sm-4">
                <img :src="resultado.logo" alt=""/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-sm-3">
        <div class="list-group">
          <div class="list-group-item text-center">
            <template v-if="resultado.tarifa">
              <div class="tarifa_leyenda">
                <desglose
                  :src="resultado.tarifa.rules[getMonedaShow]"
                ></desglose>
                <span v-html="resultado.tarifa.leyenda"></span>
              </div>

              <div class="tarifa">
                <small
                  v-text="resultado.tarifa.rules[getMonedaShow].moneda"
                ></small>
                <span
                  v-text="resultado.tarifa.rules[getMonedaShow].tarifa"
                ></span>
              </div>

              <div
                class="tarifa_origen"
                v-if="getMonedaShow !== resultado.moneda && isTarifaConector"
              >
                (
                <small
                  v-text="resultado.tarifa.rules[resultado.moneda].moneda"
                ></small>
                <span
                  v-text="resultado.tarifa.rules[resultado.moneda].tarifa"
                ></span>
                )
              </div>
            </template>
            <btn
              :href="resultado.url_reservar"
              size="sm"
              type="warning"
              block
              v-html="'Ver m&aacute;s'"
            />
          </div>
          <div class="list-group-item" v-if="isFormas && resultado.tarifa">
            <formas-de-pago
              sm="CIR"
              :conector="resultado.proveedor"
            ></formas-de-pago>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.panel {
  border: 0;
  overflow-wrap: break-word;
  white-space: normal;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);

  > .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: 0;
    margin-left: 0;

    > div {
      padding-right: 0;
      padding-left: 0;

      &:last-child {
        border-left: 1px solid #ddd;
      }

      > .img-bg {
        position: relative;
        background-size: cover;
        background-color: #ccc;
        background-repeat: no-repeat;
        background-position: center;
        width: 100%;
        height: 100%;
        min-height: 150px;
        -webkit-border-top-left-radius: 4px;
        -webkit-border-bottom-left-radius: 4px;
        -moz-border-radius-topleft: 4px;
        -moz-border-radius-bottomleft: 4px;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;

        > .img-bg-placeholder {
          top: 50%;
          left: 50%;
          color: #a3a3a3;
          width: 80px;
          height: 116px;
          margin: -58px 0 0 -40px;
          font-size: 80px;
          position: absolute;
          text-align: center;
        }

        > .label.label-destacado {
          position: absolute;
          left: 0;
          top: 20px;
          text-transform: uppercase;
          padding: 6px 10px;
          font-size: 15px;
          font-weight: 600;
          color: #fff;
          background-color: #f0ad4e;
          text-shadow: 1px 1px 0px #7b7b7b;
          box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.2);

          border-radius: 4px;
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }
      }

      > .list-group {
        margin: 0;

        > .list-group-item {
          border-left: 0;
          border-radius: 0;
          border-right: 0;
          padding: 15px 15px;

          &:first-child {
            border-top: 0;
          }
          &:last-child {
            border-bottom: 0;
          }

          > h4 {
            font-size: 18px;
            margin-bottom: 9px;
          }

          > textarea {
            width: 100%;
            height: auto;
            border: 1px dashed #ddd;
            margin: -4px -4px 5px -4px;
            display: block;
            outline: none;
            padding: 3px 3px;
            overflow: hidden;
            font-size: 18px;
            max-width: 100%;
            box-sizing: content-box;
            line-height: 19px;
            border-radius: 3px;

            &[disabled] {
              background: #ccd1d9;
              color: #656d78;
            }
          }

          > .list-inline {
            font-size: 12px;
            margin-bottom: 2px;

            &:last-child {
              margin-bottom: 0;
            }

            > li {
              &.proveedor > img {
                height: 20px;
                margin: 0 5px;
              }

              > .list-inline {
                margin-bottom: 0;
              }
            }
          }

          &.panel-admin {
            .row {
              margin-right: -5px;
              margin-left: -5px;

              > div {
                padding-right: 5px;
                padding-left: 5px;

                &:last-child {
                  text-align: right;
                }

                img {
                  max-width: 100%;
                  max-height: 30px;
                }
                ul {
                  margin: 0;
                  li {
                    font-size: 12px;
                  }
                }
              }
            }
          }

          .tarifa {
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 10px;

            > small {
              font-size: 14px;
              font-weight: 400;
            }
          }

          .tarifa_origen {
            font-size: 13px;
            font-weight: 300;
            margin-bottom: 10px;

            > small {
              font-size: 11px;
              font-weight: 200;
            }
          }

          .tarifa_leyenda {
            margin-bottom: 5px;
            font-size: 13px;
          }
        }
      }
    }
  }
}
</style>
